import {CellProps} from "react-table";
import {ClientOnline} from "_types/responses/Ws/desk/desk-client-online";
import {list2Ids} from "_utils/swr";
import {UserDeskHub} from "_services/ws/user-desk-hub";
import {useDeskSearch} from "_api/hooks/desks";
import type {DeskSearch} from "_types/requests/desk";
import {optional} from "_utils/view";

export const DeskCell = ({value, row: {original: clientOnline}}: CellProps<ClientOnline>) => {
    const ids = list2Ids(UserDeskHub.$allDesksInfo.get().map(c => c.deskId));
    const {desks} = useDeskSearch({ids} as DeskSearch);
    const desk = desks.find(d => d.id == clientOnline.deskId);

    return (
        <>{optional(desk?.name)}</>
    )
}
